import { formatForeignName, formatName } from '@/utils';
import React from 'react';

function renderUncommonWord(text) {
  return <span className="mocaofont">{text}</span>;
}

export const infoList: {
  key:
    | 'namePt'
    | 'nameCn'
    | 'informLanguage'
    | 'mobile';
  text: string;
  render?: (v) => React.ReactNode;
  renderKey?: (v, record) => React.ReactNode;
}[][] = [
  [
    {
      key: 'nameCn',
      text: '姓（中文）',
      render: (text) => {
        const [t] = formatName(text);
        return renderUncommonWord(t);
      },
    },
    {
      key: 'nameCn',
      text: '名（中文）',
      render: (text) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const [_, t] = formatName(text);
        return renderUncommonWord(t);
      },
    },
    {
      key: 'namePt',
      text: ' ',
      renderKey: (text) => {
        const [t] = formatForeignName(text);
        return t ? ' ' : '姓（外文）';
      },
      render: (text) => {
        const [t] = formatForeignName(text);
        return t;
      },
    },
    {
      key: 'namePt',
      text: ' ',
      renderKey: (text) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const [_, t] = formatForeignName(text);
        return t ? ' ' : '名（外文）';
      },
      render: (text) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const [_, t] = formatForeignName(text);
        return t;
      },
    },
  ],
];
